import axios from "axios";
import {Api_url} from "./NETWORKCONSTS";

export function invoice_query(data) {
    return axios.post(Api_url.invoice.query, data);
}
export function invoice_getHowToPay(data) {
    return axios.post(Api_url.invoice.getHowToPay, data);
}

export function invoice_getBasketByUserId(userId) {
    return axios.get(Api_url.invoice.getBasketByUserId,{params:{id:userId}});
}

export function invoice_addSubscribe(data) {
    return axios.post(Api_url.invoice.addSubscribe, data);
}

export function invoice_changeInvoiceBuyableCount(data) {
    return axios.post(Api_url.invoice.changeInvoiceBuyableCount, data);
}
export function invoice_deleteBuyable(data) {
    return axios.put(Api_url.invoice.deleteBuyable, data);
}
export function invoice_userCheckout(data) {
    return axios.post(Api_url.invoice.userCheckout, data);
}

export function invoice_applyPeriodicDiscount(data) {
    return axios.post(Api_url.invoice.applyPeriodicDiscount, data);
}

export function invoice_removePeriodicDiscount(data) {
    return axios.post(Api_url.invoice.removePeriodicDiscount, data);
}
